export function calculateGrossValue(valueNet: number, taxPercent: number, taxFixed: number): number {
    return valueNet ? valueNet * (1 + taxPercent / 100) + taxFixed : 0;
}
